import { addNotification as addNotificationUtil } from "store/notification/notification-utils";
import { useRootSelector, useRootDispatch } from "store/hooks";
import { useCallback } from "react";
import { Notification } from "store/notification/notification-slice";

export const useAddNotification = () => {
  const dispatch = useRootDispatch();
  const { isSlideOpen } = useRootSelector((state) => state.common);

  return useCallback(
    (notification: Omit<Notification, "id" | "slideout">): string => {
      return addNotificationUtil(dispatch, isSlideOpen, notification);
    },
    [dispatch, isSlideOpen]
  );
};
